import { render, staticRenderFns } from "./editProduct.vue?vue&type=template&id=73f54509&scoped=true"
import script from "./editProduct.vue?vue&type=script&lang=js"
export * from "./editProduct.vue?vue&type=script&lang=js"
import style0 from "./editProduct.vue?vue&type=style&index=0&id=73f54509&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f54509",
  null
  
)

export default component.exports